/* eslint-disable camelcase */
import {
  GET_CUSTOMER_BOOKING_PAGE,
  SET_CUSTOMER_BOOKING_PAGE,
  SET_BUSINESS_DETAIL,
  SET_BUSINESS_ID,
  SET_BUSINESS_LOCATION_ID,
  SET_BUSINESS_TYPE_ID,
} from "../constants/ActionTypes";
import { shuffleArray } from "../util/generalFunction";

const INIT_STATE = {
  data: [],
  businesses: [],
  businessId: "",
  businessLocationId: "",
  businessTypeId: 0,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CUSTOMER_BOOKING_PAGE: {
      const data = action.payload;
      let businesseList = [];
      data.map(item => {
        businesseList.push(...item.businesses);
      });
      console.log('Data list', data)
      return {
        ...state,
        data,
        businesses: shuffleArray(businesseList),
        businessTypeId: 0,
      };
    }
    case SET_BUSINESS_DETAIL: {
      const businesses = action.businesses;

      return {
        ...state,
        businesses,
      };
    }
    case SET_BUSINESS_ID: {
      const businessId = action.businessId;

      return {
        ...state,
        businessId,
      };
    }
    case SET_BUSINESS_LOCATION_ID: {
      const businessLocationId = action.businessLocationId;

      return {
        ...state,
        businessLocationId,
      };
    }
    case SET_BUSINESS_TYPE_ID:
      return {
        ...state,
        businessTypeId: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/CustomerBooking.js